
import { OnlineResultsPostRequest } from '@/dtos/resolutions/online-resolution/results/post'

export class OnlineResultsPutRequest extends OnlineResultsPostRequest {}
